import { useEffect, useState } from 'react';
import { getState, subscribe } from './pwaInstall';

// Tracks install availability. Also re-checks on display-mode changes so the
// menu item disappears the moment the app is launched as an installed PWA.
export default function usePwaInstall() {
  const [state, setState] = useState(getState);

  useEffect(() => {
    const unsubscribe = subscribe(setState);

    const media = window.matchMedia('(display-mode: standalone)');
    const onModeChange = () => setState(getState());
    media.addEventListener('change', onModeChange);

    return () => {
      unsubscribe();
      media.removeEventListener('change', onModeChange);
    };
  }, []);

  return state;
}
